<h1 mat-dialog-title>Adaptations Status</h1>
<div mat-dialog-content>
  {{
    data.applyingAdaptations === true
      ? 'Adaptations are being applied.'
      : 'Error retrieving plan adaptations. Plan will not be adapted.'
  }}
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
  <button mat-button (click)="close()">Close</button>
</div>
